// src/features/cart/api/decreaseQuantity.js
import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useMutation } from 'react-query';
import { useNotificationStore } from 'stores/notifications';

export const decreaseQuantity = (productId) => {
  return axios.patch(`/cart/decrease/${productId}`);
};

export const useDecreaseQuantity = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: decreaseQuantity,
    onSuccess: () => {
      queryClient.invalidateQueries('cart');
      addNotification({
        type: 'success',
        title: 'Quantity decreased',
      });
    },
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Update failed',
        message: 'Could not decrease item quantity. Please try again.',
      });
    },
    ...config,
  });
};
